import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch } from '../utils';

export const kube360Redirections: RedirectionStateObject = {
  'dashboard.k8s360': params => {
    const search = tanstackUrlSearch(params);

    return `/360/k8s360${search}`;
  },
};
